<template>
  <div v-if="benefit.show"
       class="benefit-bar"
  >
    <div class="benefit-date">
      {{ benefit.desc }}
    </div>
    <div v-if="countDown && countDown.endTime > 0"
         class="benefit-count-down"
    >
      {{ countDown.leftText }}
      <ym-count-down :start="countDown.currentTime"
                     :end="countDown.endTime"
                     :time-style="timeStyle"
      />
      {{ countDown.rightText }}
    </div>
  </div>
</template>

<script>
  import validator from '@/utils/validator';
  import CountDown from '@/components/CountDown';
  import { addUnit } from '@/utils';

  export default {
    name: 'BenefitBar',
    components: {
      'ym-count-down': CountDown,
    },
    props: {
      benefit: {
        required: true,
        validator(val) {
          return validator.isObject(val);
        },
      },
    },
    data() {
      return {
        timeStyle: {
          width: addUnit(40),
          height: addUnit(40),
          margin: `0 ${addUnit(10)}`,
          color: '#fa405e',
          lineHeight: 1,
          backgroundColor: '#fff',
          borderRadius: '2px',
        },
      };
    },
    computed: {
      countDown() {
        return this.benefit.countDown;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @benefit-bar-height: 60px;
  .benefit-bar {
    box-sizing: border-box;
    height: @benefit-bar-height;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: @font-size-small;
    line-height: 1;
    padding: @size-extra-small @size-base;
    background: linear-gradient(90deg, #f44049, #ff6f72);
    color: @color-white;
  }

  .benefit-date {
    display: flex;
    align-items: center;
  }

  .benefit-count-down {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
</style>
